import { TableContainer } from '@mui/material';
import { Shipment } from 'src/generated/services/TFinancialApi';
import { TableMain } from '../actionDetails/noRateCard/TableChargesShipment';
import { TableWrapper } from '../analytics/table/TableDetail';

interface TableSelectedShipmentsProps {
  shipments: string[];
  shipmentData: Shipment[]; // Add shipment data to get shipment numbers
  onDelete: (shipmentId: string) => void;
}

export const TableSelectedShipments = ({ shipments, shipmentData, onDelete }: TableSelectedShipmentsProps) => {
  if (!shipments.length) return null;

  // Helper function to get shipment number by shipmentInvoiceId
  const getShipmentNumber = (shipmentInvoiceId: string): string => {
    const shipment = shipmentData.find((s) => s.shipmentInvoiceId === shipmentInvoiceId);
    return shipment?.shipmentNumber || shipmentInvoiceId; // Fallback to ID if number not found
  };

  return (
    <div className='w-full'>
      <TableContainer
        className='rounded-2xl max-h-[280px] overflow-auto'
        component={TableWrapper}
        style={{
          border: '1px solid #DFDFDF',
          borderRadius: '8px',
        }}
      >
        <TableMain>
          <table className='w-full relative'>
            <thead className='sticky top-0 z-10'>
              <tr className='bg-[#F5F6FA]'>
                <th className='py-16 px-24 text-left text-12 font-medium text-black border-r border-neutral-20' style={{ width: '60px' }}>
                  No
                </th>
                <th className='py-16 px-24 text-left text-12 font-medium text-black border-r border-neutral-20'>Selected Shipment Number</th>
                <th className='py-16 px-24 text-center text-12 font-medium text-black' style={{ width: '80px' }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody className='overflow-auto'>
              {shipments.map((shipmentId, index) => (
                <tr key={shipmentId} className='border-t border-neutral-20'>
                  <td className='py-16 px-24 text-left text-14 border-r border-neutral-20'>{index + 1}</td>
                  <td className='py-16 px-24 text-left text-14 border-r border-neutral-20'>{getShipmentNumber(shipmentId)}</td>
                  <td className='py-16 px-24 text-center'>
                    <button type='button' className='text-red-50 hover:text-red-60 text-12' onClick={() => onDelete(shipmentId)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableMain>
      </TableContainer>
    </div>
  );
};
